import { useMemo } from 'react';

import { api } from '@/api';
import { useFctReport } from '@/shared/hook';

import { getReportOrgans } from '../../preview/preview.util';

export function useReportOrgans() {
  const { report } = useFctReport();

  const reportUuid = report?.uuid;

  const {
    data: reportOrgans,
    isFetchedAfterMount,
    isLoading,
  } = api.fct.reportOrgan.query.useGetReportOrgans(
    {
      payload: {
        reportUuid: reportUuid!,
      },
    },
    {
      enabled: Boolean(reportUuid),
    },
  );

  const updatedReportOrgans = useMemo(() => {
    if (isFetchedAfterMount && reportUuid) {
      return getReportOrgans(reportOrgans, reportUuid);
    }

    return null;
  }, [reportOrgans, isFetchedAfterMount, reportUuid]);

  return {
    isLoading,
    reportOrgans: updatedReportOrgans,
  };
}
